module.exports = __webpack_public_path__ + "static/media/Brands_9.694bcfaa.png";